export const OPTGREEN = 'opt-green';
export const GREEN = 'green';
export const YELLOW = 'yellow';
export const ORANGE = 'orange';
export const RED = 'red';
export const WHITE = 'white';
